import {Box, Container, Typography} from "@mui/material";
import DataFilter from '../../components/DataFilter';
import CardServicio from "./cardServicio";
import { categoriaServicios, dataServicios } from "../../data/dataServicios";
import {ScrollStatic} from "../../components/common/ScrollItem";
import TextToSpeech from "../../components/TextToSpeech";

const Servicios = () => {
    const accessibilityText = `
      Consulta nuestro catalogo de servicios en la barra de busquedas, tambien puedes filtrar por el servicio que necesites y en orden alfabetico.
    `;
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
        mb: { xs: "5px", sm: "10px" },
        overflow: "auto",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 15 },
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
        }}
      >
        <ScrollStatic>
          <Typography
            variant="h1"
            align="center"
            sx={{
              width: "100%",
              color: "#194AC1",
              p: "0 35px"
            }}
          >
            Servicios
          </Typography>
        </ScrollStatic>

        <TextToSpeech text={accessibilityText} />

        <ScrollStatic>
          <DataFilter categoriasList={categoriaServicios} categoriaIgual1="tipo" catergoriaIgual2="tipo" categoriaIgual3="tipo" dataItem={dataServicios} dataBusqueda="titulo" labelBusqueda={"Buscar servicio"} labelSelect={"Tipo de Servicio"} ComponentView={CardServicio} GridXs={12} GridSm={6} GridMd={4} GridLg={3} />
        </ScrollStatic>
      </Container>
    </Box>
  );
};

export default Servicios;
